var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 26.8C20.8006 26.8 26.8 20.8006 26.8 13.4C26.8 5.99938 20.8006 0 13.4 0C5.99938 0 0 5.99938 0 13.4C0 20.8006 5.99938 26.8 13.4 26.8Z",
    fill: "#43647B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 13.2L14.2 10.3L9.3 7.49998C9.1 7.39998 9 7.49998 9 7.69998V11H0.2C0.1 11.8 0 12.6 0 13.4C0 14.2 0.1 15 0.2 15.7H9V19.1C9 19.2 9.2 19.3 9.3 19.3L14.2 16.4L19.1 13.5C19.3 13.5 19.3 13.3 19.1 13.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.85467b98f754680e4dca7633f0e7bd3a.svg";
export { ForwardRef as ReactComponent };